import { $gettext } from '@/services/translations'

/**
 * Request Statuses
 */
const STARTED = 'STARTED'
const SUBMITTED = 'SUBMITTED'
const DECLINED = 'DECLINED'
const APPROVED = 'APPROVED'
const PARTIALLY_APPROVED = 'PARTIALLY_APPROVED'
const PARTIALLY_APPROVED_PENDING = 'PARTIALLY_APPROVED_PENDING'
const SUBMITTED_NEW = 'SUBMITTED_NEW'
const SUBMITTED_AWAITING_USER_REPLY = 'SUBMITTED_AWAITING_USER_REPLY'
const SUBMITTED_AWAITING_ADMIN_REPLY = 'SUBMITTED_AWAITING_ADMIN_REPLY'

const REQUEST_STATUS_LIST = [
  STARTED,
  SUBMITTED,
  DECLINED,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
]

const OPEN_REQUEST_STATUSES = [STARTED, SUBMITTED, PARTIALLY_APPROVED_PENDING]
const CLOSED_REQUEST_STATUSES = [DECLINED, APPROVED, PARTIALLY_APPROVED]

// Use this for dropdown menus
const REQUEST_STATUS_CHOICES = [
  { value: STARTED, labelEn: $gettext('Started'), labelEs: $gettext('Started', 'es_ES') },
  { value: SUBMITTED, labelEn: $gettext('Submitted'), labelEs: $gettext('Submitted', 'es_ES') },
  { value: DECLINED, labelEn: $gettext('Declined'), labelEs: $gettext('Declined', 'es_ES') },
  { value: APPROVED, labelEn: $gettext('Approved'), labelEs: $gettext('Approved', 'es_ES') },
  {
    value: PARTIALLY_APPROVED,
    labelEn: $gettext('Partially Approved'),
    labelEs: $gettext('Partially Approved', 'es_ES'),
  },
  {
    value: PARTIALLY_APPROVED_PENDING,
    labelEn: $gettext('Partially Approved Pending'),
    labelEs: $gettext('Partially Approved Pending', 'es_ES'),
  },
]

const REQUEST_SUBMITTED_STATUSES = [
  {
    value: SUBMITTED_NEW,
    labelEn: $gettext('Newly Submitted'),
    labelEs: $gettext('Newly Submitted', 'es_ES'),
  },
  {
    value: SUBMITTED_AWAITING_ADMIN_REPLY,
    labelEn: $gettext('Awaiting Admin Reply'),
    labelEs: $gettext('Awaiting Admin Reply', 'es_ES'),
  },
  {
    value: SUBMITTED_AWAITING_USER_REPLY,
    labelEn: $gettext('Awaiting User Reply'),
    labelEs: $gettext('Awaiting User Reply', 'es_ES'),
  },
]

/*
 * Request Declined Reasons
 */
const DUPLICATE = 'DUPLICATE'
const SUSPECTED_FRAUD = 'SUSPECTED_FRAUD'
const NOT_ELIGIBLE = 'NOT_ELIGIBLE'
const OVER_INDIVIDUAL_LIMIT = 'OVER_INDIVIDUAL_LIMIT'
const DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR = 'DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR'
const WITHDRAWN = 'WITHDRAWN'
const OTHER = 'OTHER'

const REASON_DECLINED_LIST = [
  DUPLICATE,
  SUSPECTED_FRAUD,
  NOT_ELIGIBLE,
  OVER_INDIVIDUAL_LIMIT,
  DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
  OTHER,
]

// Use this for dropdown menus
const REASON_DECLINED_CHOICES = [
  { value: DUPLICATE, labelEn: $gettext('Duplicate'), labelEs: $gettext('Duplicate', 'es_ES') },
  {
    value: SUSPECTED_FRAUD,
    labelEn: $gettext('Suspected Fraud'),
    labelEs: $gettext('Suspected Fraud', 'es_ES'),
  },
  {
    value: NOT_ELIGIBLE,
    labelEn: $gettext('Not Eligible'),
    labelEs: $gettext('Not Eligible', 'es_ES'),
  },
  {
    value: OVER_INDIVIDUAL_LIMIT,
    labelEn: $gettext('Over Individual Limit'),
    labelEs: $gettext('Over Individual Limit', 'es_ES'),
  },
  {
    value: DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
    labelEn: $gettext('Documentation (none, insufficient, unclear)'),
    labelEs: $gettext('Documentation (none, insufficient, unclear)', 'es_ES'),
  },
  {
    value: WITHDRAWN,
    labelEn: $gettext('Withdrawn'),
    labelEs: $gettext('Withdrawn', 'es_ES'),
  },
  {
    value: OTHER,
    labelEn: $gettext('Other'),
    labelEs: $gettext('Other', 'es_ES'),
  },
]

/**
 * Documentation Types
 */
const EVENT = 'EVENT'
const EXPENSE = 'EXPENSE'

export default {
  STARTED,
  SUBMITTED,
  DECLINED,
  APPROVED,
  PARTIALLY_APPROVED,
  PARTIALLY_APPROVED_PENDING,
  REQUEST_STATUS_LIST,
  REQUEST_STATUS_CHOICES,
  OPEN_REQUEST_STATUSES,
  CLOSED_REQUEST_STATUSES,
  DUPLICATE,
  SUSPECTED_FRAUD,
  NOT_ELIGIBLE,
  OVER_INDIVIDUAL_LIMIT,
  DOCUMENTATION_INSUFFICIENT_OR_UNCLEAR,
  OTHER,
  REASON_DECLINED_LIST,
  REASON_DECLINED_CHOICES,
  EVENT,
  EXPENSE,
  SUBMITTED_NEW,
  SUBMITTED_AWAITING_USER_REPLY,
  SUBMITTED_AWAITING_ADMIN_REPLY,
  REQUEST_SUBMITTED_STATUSES,
}
